import { StaticBaseDao } from '@/dao';
import { ContestantInfoResponse } from '@/objects/generated';

export class ContestantFavoriteDao extends StaticBaseDao {
    public static async GetWikipediaInfo(eventID: number, contestantID: number): Promise<ContestantInfoResponse | null> {
        return this.BaseFetch(
            ContestantInfoResponse,
            `ContestantFavorite/GetWikipediaInfo` +
                '?' +
                (eventID == undefined ? '' : `eventID=${eventID}`) +
                '&' +
                (contestantID == undefined ? '' : `contestantID=${contestantID}`),
            'GET',
        );
    }
}
